import "core-js/modules/es.array.last-index-of";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/drone_race_manage/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  data: function data() {
    return {
      dialogVisible: false,
      messageData: {
        content: ''
      },
      messageList: [],
      index: 0,
      fileName: ''
    };
  },
  created: function created() {},
  computed: {},
  methods: {
    init: function init(list) {
      this.messageList = list;
      this.getMsgDetil();
    },
    nextMesg: function nextMesg() {
      if (this.index + 1 < this.messageList.length) {
        this.index++;
        this.getMsgDetil();
      } else {
        this.dialogVisible = false;
      }
    },
    getMsgDetil: function getMsgDetil() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var query, pos;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$api.messageDetail({
                  message_id: _this.messageList[_this.index].id
                });

              case 2:
                query = _context.sent;

                if (query.code == 200) {
                  if (query.data.message.file) {
                    pos = query.data.message.file.lastIndexOf('/'); // '/'所在的最后位置

                    _this.fileName = query.data.message.file.substr(pos + 1); //截取文件名称和后缀   输出：香菜.png
                  }

                  _this.readMsg(query.data.message.id);

                  _this.messageData = query.data.message;
                  _this.dialogVisible = true;
                }

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    readMsg: function readMsg(id) {
      this.$api.readMessage({
        message_id: id
      }).then(function (res) {
        if (res.code == 200) {}
      });
    }
  }
};